import { Loader2 } from "lucide-react";
import { motion } from "framer-motion";

export function LoadingStateSection() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="flex flex-col items-center justify-center p-8 space-y-4"
    >
      <Loader2 className="h-8 w-8 text-amber-600 animate-spin" />
      <p className="text-gray-600 animate-pulse">Laster saker...</p>
    </motion.div>
  );
}